import { installInputClear } from './utils/inputClear.mjs';
import './input-clear.css';
import { installDecimalInputGuard } from './utils/decimalInput.mjs';
import { createApp } from 'vue'
import { installModalAccessibility } from './utils/modalAccessibility.js'
import App from './App.vue'
import { appConfig } from './config/env'
import './style.css'
import './select.css'
import './reference.css'
import './pixel-alignment.css'

document.documentElement.dataset.appEnv = appConfig.env
window.__APP_CONFIG__ = appConfig


if (typeof document !== 'undefined') installDecimalInputGuard();
const app = createApp(App);
const disposeInputClear = installInputClear(app);
if (import.meta.hot) import.meta.hot.dispose(disposeInputClear);
app.mount('#app');
const disposeModalAccessibility = installModalAccessibility(document.body);
if (import.meta.hot) import.meta.hot.dispose(disposeModalAccessibility);
